import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

const initialState = {
  leaveTypeList: [],
  loading: false,
  error: '',
};

export const fetchLeaveType = createAsyncThunk(
  'leaveType/fetchLeaveType',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetLeaveType();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: item.name,
          value: item.id,
          key: item.id,
        })) ?? [];

      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const leaveTypeSlice = createSlice({
  name: 'leaveType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeaveType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveType.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveTypeList = action.payload;
        state.error = '';
      })
      .addCase(fetchLeaveType.rejected, (state, action) => {
        state.loading = false;
        state.leaveTypeList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default leaveTypeSlice.reducer;
